import { FaCalculator, FaGlobe, FaSync } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import TextField from "components/ui/controls/text-field/text-field";
import Modal from "components/ui/modal/modal";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import _ from "lodash";
import Button from "components/ui/controls/button/button";

const StrategiePERDisponible163 = (props) => {
  const context = useContext(AppContext);
  const dt = new Date();
  const yearM1 = dt.getFullYear() - 1;
  const yearM2 = dt.getFullYear() - 2;
  const yearM3 = dt.getFullYear() - 3;
  const year = dt.getFullYear();

  console.log(props);
  const handleChangeValue = (Year, Property, Value) => {
    let Values = _.cloneDeep(context.state.StrategiePERDisponibleTabPlafond163);
    if (Property === "SetClient" && Value === false) {
      Values[Year]["Client"] = props?.Disponible163Calcule;
    }
    Values[Year][Property] = Value;

    if (Year === year && (Property === "Client" || Property === "Conjoint")) {
      Values[Year]["Set" + Property] = true;
    }
    context.handleValueChange("StrategiePERDisponibleTabPlafond163", Values);
  };

  const handleMutuPlafond = (value) => {
    context.handleValueChange("StrategiePERDisponiblMutuPlafond", value);
    // handleCalculPlafondDeduction(tabCorrectionPER, value);
  };
  // const handleCalculPlafondDeduction = (Values, MutuPlafond) => {
  //   let PlafondClient =
  //     Number(Values[year]["DispoPERCorrige"]) + Number(Values[yearM1]["DispoPERCorrige"]) + Number(Values[yearM2]["DispoPERCorrige"]) + Number(Values[yearM3]["DispoPERCorrige"]);
  //   let PlafondConjoint =
  //     Number(Values[year]["DispoPERCorrigeConjoint"]) +
  //     Number(Values[yearM1]["DispoPERCorrigeConjoint"]) +
  //     Number(Values[yearM2]["DispoPERCorrigeConjoint"]) +
  //     Number(Values[yearM3]["DispoPERCorrigeConjoint"]);
  //   if (MutuPlafond === "oui") {
  //     PlafondClient += PlafondConjoint;
  //     PlafondConjoint = 0;
  //   }
  //   setPlafondClient(PlafondClient);
  //   setPlafondConjoint(PlafondConjoint);
  //   context.handleValueChange("CorrectionPER", Values);
  // };

  return (
    <>
      <Modal
        width="65%"
        height="60%"
        title=" Disponible fiscal 163 quatervicies"
        icon={<FaGlobe />}
        visible={props.visible}
        onClose={() => {
          props?.onClose?.();
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <div className="revenuspro-container" style={{ marginBottom: "20px" }}>
                      {/* Header des colonnes */}
                      <div className="header-card">
                        <div className="category-column" style={{ textAlign: "left", flex: 2 }}>
                          Paramètres
                        </div>
                        <div className="value-column" style={{ textAlign: "center" }}>
                          Client
                        </div>
                        <div className="value-column" style={{ textAlign: "center", width: "62px", minWidth: "62px", flex: "none" }}>
                        </div>
                        <div className="value-column" style={{ textAlign: "center" }}>
                          Conjoint
                        </div>
                      </div>
                      {/* Conteneur des cartes de contenu */}
                      <div className="card-list-container">
                        
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">📅</div>
                            Plafond non utilisé pour les revenus de {yearM3}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[yearM3]?.Client}
                              onChange={(e) => {
                                handleChangeValue(yearM3, "Client", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                          <div className="value-column" style={{ width: "62px", minWidth: "62px", flex: "none" }}>
                            {/* Colonne vide pour les actions */}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[yearM3]?.Conjoint}
                              onChange={(e) => {
                                handleChangeValue(yearM3, "Conjoint", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">📅</div>
                            Plafond non utilisé pour les revenus de {yearM2}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[yearM2]?.Client}
                              onChange={(e) => {
                                handleChangeValue(yearM2, "Client", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                          <div className="value-column" style={{ width: "62px", minWidth: "62px", flex: "none" }}>
                            {/* Colonne vide pour les actions */}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[yearM2]?.Conjoint}
                              onChange={(e) => {
                                handleChangeValue(yearM2, "Conjoint", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">📅</div>
                            Plafond non utilisé pour les revenus de {yearM1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[yearM1]?.Client}
                              onChange={(e) => {
                                handleChangeValue(yearM1, "Client", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                          <div className="value-column" style={{ width: "62px", minWidth: "62px", flex: "none" }}>
                            {/* Colonne vide pour les actions */}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[yearM1]?.Conjoint}
                              onChange={(e) => {
                                handleChangeValue(yearM1, "Conjoint", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🧮</div>
                            Plafond calculé sur les revenus de {yearM1}
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[year]?.Client}
                              onChange={(e) => {
                                handleChangeValue(year, "Client", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                          <div >
                            <Column>
                            
                            <Button
                              style={{ justifyContent: "center" }}
                              tabIndex="-1"
                              icon
                              onClick={() => {
                                handleChangeValue(year, "SetClient", false);
                              }}
                            >
                              {context.state["StrategiePERContratSetTauxConversion"] === false ? (
                                <FaCalculator style={{ backgroundColor: "rgb(219, 234, 254)", color: "rgb(59, 130, 246)", padding: "8px 17px 8px 17px", borderRadius: "6px" }} />
                              ) : (
                                <FaSync style={{ backgroundColor: "rgb(219, 234, 254)", color: "rgb(59, 130, 246)", padding: "8px 17px 8px 17px", borderRadius: "6px", fontSize: "12px" }} />
                              )}
                            </Button>
                            </Column>
                          </div>
                          <div className="value-column">
                            <TextField
                              value={context.state.StrategiePERDisponibleTabPlafond163[year]?.Conjoint}
                              onChange={(e) => {
                                handleChangeValue(year, "Conjoint", e.target.value);
                              }}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </div>
                        </div>
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">🤝</div>
                            Mutualisation des plafonds
                          </div>
                          <div className="value-column">
                            <DropDown
                              value={context.state.StrategiePERDisponiblMutuPlafond}
                              onChange={(e) => {
                                handleMutuPlafond(e.target.value);
                              }}
                              options={[
                                { value: "Non", label: "Non" },
                                { value: "Oui", label: "Oui" },
                              ]}
                            />
                          </div>
                          <div className="value-column" style={{ width: "62px", minWidth: "62px", flex: "none" }}>
                            {/* Colonne vide pour les actions */}
                          </div>
                          <div className="value-column">{/* Colonne vide pour le conjoint */}</div>
                        </div>
                      </div>
                    </div>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                props?.onClose?.();
                props?.CalculDisponible();
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

export default StrategiePERDisponible163;
